import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

const InputSkeleton = () => (
  <Box gap="s8">
    <Skeleton height="s16" width="s120" />
    <Skeleton height="s40" width="full" />
  </Box>
)

const TwoColumnRow = () => (
  <Grid variant="fixed">
    <Box gridColSpan={{ xxs: 1, xs: 6 }}>
      <InputSkeleton />
    </Box>
    <Box gridColSpan={{ xxs: 1, xs: 6 }}>
      <InputSkeleton />
    </Box>
  </Grid>
)

export const NewVacancyRequisitionModalSkeleton = () => {
  return (
    <Box width="full" gap="s16">
      <Skeleton height="s20" width="s140" />
      <TwoColumnRow />

      <Skeleton height="s20" width="s140" />
      {Array.from({ length: 4 }).map((_, idx) => (
        <TwoColumnRow key={idx} />
      ))}
      <InputSkeleton />

      <Skeleton height="s20" width="s140" />
      <Grid variant="fixed">
        <Box gridColSpan={{ xxs: 1, xs: 4 }}>
          <InputSkeleton />
        </Box>
        <Box gridColSpan={{ xxs: 1, xs: 4 }}>
          <InputSkeleton />
        </Box>
        <Box gridColSpan={{ xxs: 1, xs: 4 }}>
          <InputSkeleton />
        </Box>
      </Grid>
      <InputSkeleton />

      <InputSkeleton />
    </Box>
  )
}
